import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { ApiService } from '../http/api.service';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../http/modal/header';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceService {
  constructor(
    private readonly us: UtilityService,
    private readonly apiService: ApiService
  ) { }

  getWorkspaceList(type, accountId?) {
    return new Promise((resolve, reject) => {
      let data = {
        filterType: type.toUpperCase(),
        userId: this.us.getUserId(),
      };
      if (accountId) {
        data['accountId'] = accountId;
      }
      const queryParam = this.us.getObjToQueryParam(data);
      this.us.showLoader();
      this.getWorkspaceData(queryParam).subscribe((res) => {
        this.us.hideLoader();
        if (res && res['code'] === 'success') {
          if (res['data'] && res['data'].length > 0) {
            this.getUserDetails(res['data']);
            resolve(res['data']);
          } else {
            reject(res['data']);
          }
        }
      });
    });
  }

  getUserDetails(list) {
    let data = {
      userList: list.map((ele) => ele.invitedBy),
    };
    this.getBulkDetails(data).subscribe((res) => {
      if (res && res['code'] === 'success') {
        if (res['data'] && res['data'].length > 0) {
          list = this.userHandleResponse(res['data'], list);
        }
      }
    });
  }

  userHandleResponse(responseData, list) {
    list.forEach((ele) => {
      let obj = responseData.find((ele1) => ele1.userId == ele.invitedBy);
      if (obj) {
        ele['createdBy'] = obj.displayName;
        ele['imageUrl'] = obj.imageUrl;
        ele['emailId'] = obj.email;
      }
    });
    return list;
  }

  getBulkDetails(data) {
    const path = `/user/bulk-detail`;
    return this.apiService.post(`${environment.url}${path}`, data, {
      headers: getHeaders(),
    });
  }

  getSharedLink(queryParam) {
    const path = `/workspace/sharable-link?${queryParam}`;
    return this.apiService.get(`${environment.accountUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  shareRequest(data, workspaceId) {
    const path = `/workspace/share?workspaceId=${workspaceId}`;
    return this.apiService.post(`${environment.accountUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  getWorkspaceData(data) {
    const path = `/workspace/filter?${data}`;
    return this.apiService.get(`${environment.accountUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  addWorkspace(data) {
    const path = '/workspace';
    return this.apiService.post(`${environment.accountUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  updateWorkspace(data) {
    const path = '/workspace';
    return this.apiService.put(`${environment.accountUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  acceptRejectInvitation(data) {
    const path = `/user/invite-action?${data}`;
    return this.apiService.get(`${environment.url}${path}`, {
      headers: getHeaders(),
    });
  }

  joinRequest(data, requestParam) {
    const path = `/workspace/join-request?${requestParam}`;
    return this.apiService.post(`${environment.accountUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  leaveWorkspaceRequest(data, workspaceId) {
    const path = `/workspace/leave-request?workspaceId=${workspaceId}`;
    return this.apiService.post(`${environment.accountUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  getWorkspaceById(data) {
    const path = `/workspace?${data}`;
    return this.apiService.get(`${environment.accountUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  getResourceGroupApi() {
    const path = '/resource/resourceGroups';
    return this.apiService.get(`${environment.resourceUrl}${path}`,{
      headers: getHeaders(),
    });
  }

  getTeamApi(queryParam) {
    const path = `/team/filter?${queryParam}`;
    return this.apiService.get(`${environment.resourceUrl}${path}`, {
      headers: getHeaders(),
    });
  }

   getResourceListApi(queryParam) {
    const path = `/resource/filter?${queryParam}`;
    return this.apiService.get(`${environment.resourceUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  roleListApi(queryParam) {
    let path = `/role/filter?${queryParam}`;
    return this.apiService.get(`${environment.resourceUrl}${path}`, {
      headers: getHeaders(),
    });
  }
}
